__turbopack_context__.v({
  "className": "oswald_9ce24079-module__g-QvyW__className",
});
